import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16b29b90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-box" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("发送邮件")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("批量下载发票")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("打印发票")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("下载发票")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("批量导入")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("税务批量开票模板")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("批量填写开票日期")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("批量下载")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("批量下载发票")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("重开")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("作废")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("交付订单")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("附件")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("驳回")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("点击上传")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("点击上传")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("确定")

import { ref, Ref, reactive, onMounted } from 'vue'
import dayjs from 'dayjs'
import { boolean, ceil, string } from 'mathjs'
import EptBtn from '@/components/ExportButton.vue'
import { useRoute } from 'vue-router'
import { exportHandle, formatNumber,getNumber } from '@/utils/index'
import Api from '@/http/modules/index'
import { ElMessageBox,ElMessage } from 'element-plus'
import { genFileId } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  props: {
    isInvoice:{
       type:Boolean,
       default:true
    }
},
  emits: ['print','again','recreate'],
  setup(__props, { expose, emit }) {

const props = __props


let {
    // 发票列表
    'POST/order/invoice/list':invoiceListApi,
    // 发票列表
    'POST/order/invoice/vat/list':vatInvoiceListApi,
    // 增值税发票订单列表
    'GET/order/invoice/vat/{id}/orders':vatInvoiceOrdersApi,
    // 增值税开票记录（导出）
    'POST/order/vat_record/export':vatRecordExportApi,
    // 增值税开票记录（导入）
    'POST/order/vat_record/import':vatRecordImportApi,
    // 税务批量开票模板（导出）
    'POST/order/vat_record/template':vatRecordTemplateApi,
    // 发票驳回
    'POST/order/invoice/vat/reject':vatInvoiceRejectApi,
    // 发票重新申请
    'POST/order/invoice/vat/again':vatInvoiceAgainApi,
    // 发送邮件（信息获取）
    'POST/order/invoice/send_mail/info':emailInfoApi,
    // 发送邮件
    'POST/order/invoice/send_mail':seadEmailApi,
    // 增值税发票上传识别
    'POST/order/invoice/vat/upload':vatUploadApi,
    // 批量修改真实开票日期
    'POST/order/invoice/vat/update/date':vatUpdateDateApi,
    // 增值税发票附件下载
    'POST/order/invoice/vat/download':vatDownLoadApi,
    // 发票pdf下载
    'POST/order/invoice/pdf_download':pdfInvoiceDownloadApi,
    // 销售作废发票
    'PUT/order/invoice/vat/negate':vatNegateApi,
    // 增值税发票上传识别（批量）
    'POST/order/invoice/vat/batch_upload':vatBatchUploadApi,
    // 增值税发票附件删除
    'DELETE/order/invoice/vat/delete/:id':vatDeleteApi,
    // 增值税发票附件列表
    'GET/order/invoice/vat/upload/files':vatUploadFilesApi,
    // 根据发票号、类型批量下载发票
    'POST/order/invoice/batch_download':invoiceBatchDownloadApi,
    // 交付订单
    'POST/order/vat_record/create_ref':deliverApi

} = Api
const route=useRoute()
const tableHeight=window.innerHeight-270

const invoiceForm=ref<any>({
    hasDiffAmount:false
})
const invoiceLists=ref([])
const invoiceListsLoading=ref(false)
const statusList=[
    {value:"APPLY_FOR",label:"申请中"},
    {value:"COMPLETE",label:"已完成"},
    {value:"APPLY_AGAIN",label:"已申请重开"},
    {value:"VOIDING",label:"作废中"},
    {value:"VOID",label:"已作废"},
    {value:"REJECT",label:"已驳回"},
    {value:"VOID_RED",label:"已冲红"},
    {value:"WAIT_DELIVERED",label:"待交付"},
    {value:"DELIVERED",label:"已交付"},
]
const pageInfo=reactive({
    page:1,
    size:30,
    total:0
})
const vatInvoiceSumData=ref<any>({})
const getInvoiceLists=(isReset:boolean=false)=>{
    if(isReset){
        invoiceForm.value={
            hasDiffAmount:false
        }
        pageInfo.page=1,
        pageInfo.size=30
    }   
    let {page,size}=pageInfo
    let {invoiceNo,customerManager,createTime,realNo,customerName,realInvoiceDate,hasDiffAmount,status,companyId,no,buyerName}=invoiceForm.value
    let params:any={
        page,size,invoiceNo,customerManager,companyId,no,buyerName,
        createdAtFrom:createTime?dayjs(createTime[0]).format('YYYY-MM-DD'):'',
        createdAtTo:createTime?dayjs(createTime[1]).format('YYYY-MM-DD'):'',
        customerName

    }
    if(!props.isInvoice){
        params.realNo=realNo  
        // params.customerName=customerName 
        params.realInvoiceDateFrom=realInvoiceDate?dayjs(realInvoiceDate[0]).format('YYYY-MM-DD'):''
        params.realInvoiceDateTo=realInvoiceDate?dayjs(realInvoiceDate[1]).format('YYYY-MM-DD'):''
        params.hasDiffAmount=hasDiffAmount?true:false
        params.status=status
    }
    invoiceListsLoading.value=true
    let listApi=props.isInvoice?invoiceListApi:vatInvoiceListApi
    listApi(params).then((res:any)=>{
        invoiceLists.value=res.data
        pageInfo.total=res.rowCount
        vatInvoiceSumData.value=res?.sum
    }).finally(()=>{
        invoiceListsLoading.value=false
    })
}
const printInvoice=(data:any,option:string)=>{
    emit('print',{data,option})
}
// 获取详情
const vatInvoiceOrderLists=ref([])
const vatInvoiceListVisiable=ref(false)
const getVatInvoiceOrders=(id:any)=>{
    vatInvoiceOrdersApi({id}).then((res:any)=>{
        vatInvoiceListVisiable.value=true
        vatInvoiceOrderLists.value=res
    })
}
// 导出
const exportLoading=ref(false)
const exportTempLoading=ref(false)
const vatRecordExoprt=(isTemplate:boolean=false)=>{
    let {page,size}=pageInfo
    let {invoiceNo,customerManager,createTime,companyId,no,status,realInvoiceDate}=invoiceForm.value
    let params={
        page,size,invoiceNo:invoiceNo||'',customerManager:customerManager||'',
        createdAtFrom:createTime?dayjs(createTime[0]).format('YYYY-MM-DD'):'',
        createdAtTo:createTime?dayjs(createTime[1]).format('YYYY-MM-DD'):'',companyId:companyId||'',no:no||'',
        ids:vatSelectedLists.value.length?vatSelectedLists.value.map((el:any)=>el.id):[],
        status:status||null,
        realInvoiceDateFrom:realInvoiceDate?dayjs(realInvoiceDate[0]).format('YYYY-MM-DD'):'',
        realInvoiceDateTo:realInvoiceDate?dayjs(realInvoiceDate[1]).format('YYYY-MM-DD'):''
    }        
    exportLoading.value=!isTemplate
    exportTempLoading.value=isTemplate
    let handleMethod=isTemplate?vatRecordTemplateApi:vatRecordExportApi
    handleMethod(params,{ timeout: 5 * 60000, responseType: 'blob' }).then((res:any)=>{
        let fileName = decodeURI(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
        let url = window.URL.createObjectURL(
            new Blob([res.data], { type: res.headers['content-type'] })
        )

        let link = document.createElement("a")
        link.style.display = "none"
        link.href = url
        link.setAttribute(
            "download",
            decodeURI(fileName)
        )
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }).finally(()=>{
        exportLoading.value=false
        exportTempLoading.value=false
    })
}
// 驳回 
const voidHandle=(id:any)=>{
    ElMessageBox.confirm('当前发票是否驳回？',{confirmButtonText:'确认',cancelButtonText:"取消"}).then(()=>{
        let params={
            ids:[id]
        }
        vatInvoiceRejectApi(params).then(()=>{
            ElMessage.success("操作成功")
            getInvoiceLists()
        })
    })
}
// 重新申请
// const applyAgain=(row:any)=>{
//     emit('again',row.orderNos)
// }

// 发送邮件
const emailVisiable=ref(false)
const emailFormRef=ref()
const emailInfo=ref<any>({})
const invoiceSelected=ref([])
const sendLoading=ref(false)
const handleSelectionChange=(val:any)=>{
    invoiceSelected.value=val
}
const getEmailInfo=()=>{
    if(!invoiceSelected.value.length){
        ElMessage.warning("请勾选需要发票数据")
        return
    }
   let res= invoiceSelected.value.every((el:any)=>el.customerUsername==(invoiceSelected.value[0] as any).customerUsername)
    if(!res){
        ElMessage.warning("勾选相同客户发票")
        return
    }
    let params={
        customerUsername:(invoiceSelected.value[0] as any).customerUsername,
        ids:invoiceSelected.value.map((el:any)=>el.id)
    }
    emailInfoApi(params).then((res:any)=>{
        emailInfo.value=res
        emailVisiable.value=true
    })
}
const sendEmail=async(formEl:any)=>{
    if (!formEl) return
    await formEl.validate((valid:any, fields:any) => {
        if (valid) {
            let {toAddress, ccAddress, title, type,contact}=emailInfo.value
            let params={
                toAddress, ccAddress, title, type,contact,
                ids:invoiceSelected.value.map((el:any)=>el.id)
            }
            sendLoading.value=true
            seadEmailApi(params).then(()=>{
                ElMessage.success("发送成功")
                emailVisiable.value=false
            }).finally(()=>{
                sendLoading.value=false
            })
        }
    })
}
const closeEmail=(formEl:any)=>{
    if (!formEl) return
    formEl.resetFields()
    emailInfo.value={}    
}
const tableRowClassName = ({ row, rowIndex }: any) => {
  if (row.sumOrderAmount != row.totalAmount) {
    return 'danger-corlor-row'
  }
  return ''
}
// 上传附件
const uploadVisiable=ref(false)
const uploadRef=ref()
const currentVatInfo=ref<any>({})
const uploading=ref(false)
// const handleExceed=(files:any)=>{
//     uploadRef.value!.clearFiles()
//     const file = files[0] as any
//     file.uid = genFileId()
//     uploadRef.value!.handleStart(file)
// }
const uploadHandle=(row:any)=>{
    currentVatInfo.value=row
    uploadVisiable.value=true
    getUploadFiles(row.id) 
}
const uploadMethod=(file:any)=>{
    let params={
        id:currentVatInfo.value.id, //{contentType: 'formData'}
        note:'',
        files:file.file
    }
    uploading.value=true
    vatUploadApi(params,{contentType: 'formData'}).then((res:any)=>{
        ElMessage.success("上传成功")
        // uploadVisiable.value=false
        getUploadFiles(currentVatInfo.value.id)
    }).finally(()=>{
        uploading.value=false        
    })
}
const resetUpload=()=>{
    currentVatInfo.value={}
    uploadRef.value!.clearFiles()
}
// 批量填写开票日期
const batchDateVisiable=ref(false)
const batchInvoiceDate=ref("")
const vatSelectedLists=ref([])
const updateDateLoading=ref(false)
const updateHandle=()=>{
    if(!vatSelectedLists.value.length){
        ElMessage.warning("请先勾选操作数据")
        return 
    }
    batchDateVisiable.value=true
}
const vatSelectionChange=(val:any)=>{
    vatSelectedLists.value=val
}
const resetHandle=()=>{
    batchInvoiceDate.value=''
}
const bantchHandle=()=>{    
    if(!batchInvoiceDate.value){
        ElMessage.warning("请选择开票日期")
        return 
    }
    let params={
        ids:vatSelectedLists.value.map((el:any)=>el.id),
        realInvoiceDate:dayjs(batchInvoiceDate.value).format('YYYY-MM-DD')
    }
    updateDateLoading.value=true
    vatUpdateDateApi(params).then(()=>{
        ElMessage.success('操作成功')
        getInvoiceLists()
        batchDateVisiable.value=false
        updateDateLoading.value=false
    })

}

// 批量下载发票上传的附件
const bantchDownLoadLoading=ref(false)
const singleVatDownLoadLoading=ref(false)
const bantchDownLoad=(isBatch:boolean=true,id?:any)=>{
    if(isBatch&&!vatSelectedLists.value.length){
        ElMessage.warning("请先勾选操作数据")
        return 
    }
    // isBatch控制是否是批量下载，单独下载传id .默认批量下载
    let ids:any=[]
    if(isBatch){
        vatSelectedLists.value.forEach((el:any)=>{
            if(el.vatFiles.length){
                let tgt=el.vatFiles.map((el:any)=>el.id)
                ids.push(...tgt)
            }
        })        
    } 
    bantchDownLoadLoading.value=isBatch
    singleVatDownLoadLoading.value=!isBatch
    vatDownLoadApi({ids:isBatch?ids.join(','):id},{contentType: 'formData', timeout: 5 * 60000, responseType: 'blob' }).then((res:any)=>{
        let fileName = decodeURI(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
        let url = window.URL.createObjectURL(
            new Blob([res.data], { type: res.headers['content-type'] })
        )

        let link = document.createElement("a")
        link.style.display = "none"
        link.href = url
        link.setAttribute(
            "download",
            decodeURI(fileName)
        )
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }).finally(()=>{
        bantchDownLoadLoading.value=false
        singleVatDownLoadLoading.value=false
    })
}


// 销售发票作废
const negateReason=ref('')
const negateReaonVisiable=ref(false)
const negateIvoiceInfo=ref<any>({})
const negateHandle=(row:any)=>{
    negateIvoiceInfo.value=row
    negateReaonVisiable.value=true
}
const negateMethod=()=>{
    if(!negateReason.value){
        ElMessage.warning("请输入发票作废的原因")
        return
    }
    let params={
        id:negateIvoiceInfo.value.id,
        reason:negateReason.value
    }
    vatNegateApi(params,{contentType: 'formData'}).then(()=>{
        negateReaonVisiable.value=false
        ElMessage.success('操作成功')
        getInvoiceLists()
    })
}
// 重开发票
const recreateHandle=(row:any)=>{
    emit('recreate',row)
}
// 批量导入
const batchUploadVisiable=ref(false)
const fileList=ref<any>([])
const batchUploadRef=ref()
const batchUploadLoading=ref(false)
const batchUploadHandle=()=>{
    batchUploadVisiable.value=true
}
const bantchUploadMethod=()=>{
    console.log(fileList.value,'filelist')
    if(!fileList.value.length){
        ElMessage.warning('请选择要上传的文件')
        return
    }
    const formData = new FormData()
    fileList.value.forEach((file:any)=>{
        formData.append(`files`,file.raw)
    })
    batchUploadLoading.value=true
    vatBatchUploadApi(formData).then((res:any)=>{
        batchUploadVisiable.value=false
        if(!res.length){ //空数组表示上传成功
            ElMessage.success("上传成功")            
            getInvoiceLists()
            return
        }        
        ElMessageBox.confirm(res.join('，'),{confirmButtonText:"确定",title:'找不到以下增值税发票信息',showCancelButton:false})
    }).finally(()=>{
        batchUploadLoading.value=false
    })
}
const resetBatchUpload=()=>{
    fileList.value=[]
    batchUploadRef.value.clearFiles()
}
// 发票已上传附件列表
const vatUploadFiles=ref([])
const vatUploadFilesLoading=ref(false)
const getUploadFiles=(invoiceId:string)=>{
    vatUploadFilesLoading.value=true
    vatUploadFilesApi({invoiceId}).then((res:any)=>{
        vatUploadFiles.value=res
    }).finally(()=>{
        vatUploadFilesLoading.value=false
    }) 
}
// 删除附件
const vatDeleteHandle=async (id:any)=>{
    let res=await ElMessageBox.confirm("确定删除附件？",{confirmButtonText:"确定",cancelButtonText:'取消'})
    if(!res) return
    vatDeleteApi({id}).then(()=>{
        getUploadFiles(currentVatInfo.value.id)
        ElMessage.success("操作成功")
        getInvoiceLists()
    })
}

//根据no的几个批量导出发票
const isShowExport=ref(false)
const exportNos=ref("")
const batchExportLoading=ref(false)
const batchExportHandle=()=>{
    let params={
        nos:exportNos.value,
        type:props.isInvoice?'INVOICE':'VAT'
    }
    batchExportLoading.value=true
    exportHandle(invoiceBatchDownloadApi,params, {contentType: 'formData'}).finally(()=>{
        batchExportLoading.value=false
    })    
}
// 交付订单
const deliverHandle=(id:any)=>{
    ElMessageBox.confirm('确定交付订单？',{confirmButtonText:"确定",cancelButtonText:'取消'}).then(()=>{
        deliverApi({id}).then(()=>{
            ElMessage.success('操作成功')
        })
    })
}
const getSummaries=({columns}:any)=>{
    const sums:any = []
    columns.forEach((column:any, index:any) => {
        if(index==0){
            sums[index] = '合计'
        }else{
            console.log(column.property)
            sums[index]=column.property
            if(column.property=='totalAmount'||column.property=='sumOrderAmount'||column.property=='advanceVatInvoiceAmount'){
                sums[index]=getNumber(vatInvoiceSumData.value[column.property])  
            }else{
                sums[index]=''
            }
        }
    })
    return sums
}
onMounted(()=>{    
    getInvoiceLists()
})
expose({
    getInvoiceLists
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Upload = _resolveComponent("Upload")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "点击搜索" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_form, {
                inline: "",
                "label-width": "130px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "订单号：" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        style: {"width":"220px"},
                        modelValue: invoiceForm.value.no,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((invoiceForm.value.no) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "发票编号：" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: invoiceForm.value.invoiceNo,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((invoiceForm.value.invoiceNo) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (!props.isInvoice)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "发票号码："
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: invoiceForm.value.realNo,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((invoiceForm.value.realNo) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, { label: "客户经理：" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: invoiceForm.value.customerManager,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((invoiceForm.value.customerManager) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "客户名称：" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: invoiceForm.value.customerName,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((invoiceForm.value.customerName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (!props.isInvoice)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: "购买方"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: invoiceForm.value.buyerName,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((invoiceForm.value.buyerName) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!props.isInvoice)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 2,
                        label: "公司名称"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: invoiceForm.value.companyId,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((invoiceForm.value.companyId) = $event)),
                            placeholder: "请选择公司",
                            filterable: "",
                            clearable: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysCompany, (group) => {
                                return (_openBlock(), _createBlock(_component_el_option_group, {
                                  label: group.label,
                                  key: group.label
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (comp) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        label: comp.name,
                                        value: comp.id,
                                        key: comp.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!props.isInvoice)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 3,
                        label: "状态"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: invoiceForm.value.status,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((invoiceForm.value.status) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusList, (item) => {
                                return _createVNode(_component_el_option, {
                                  key: item.value,
                                  value: item.value,
                                  label: item.label
                                }, null, 8, ["value", "label"])
                              }), 64))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, { label: "申请日期：" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: invoiceForm.value.createTime,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((invoiceForm.value.createTime) = $event)),
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始时间",
                        "end-placeholder": "结束时间",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (!props.isInvoice)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 4,
                        label: "开票日期"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: invoiceForm.value.realInvoiceDate,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((invoiceForm.value.realInvoiceDate) = $event)),
                            type: "daterange",
                            "range-separator": "至",
                            "start-placeholder": "开始时间",
                            "end-placeholder": "结束时间",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!props.isInvoice)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 5,
                        label: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox, {
                            modelValue: invoiceForm.value.hasDiffAmount,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((invoiceForm.value.hasDiffAmount) = $event)),
                            label: "存在金额差异",
                            size: "large"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (getInvoiceLists()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (getInvoiceLists(true)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (props.isInvoice)
      ? (_openBlock(), _createBlock(_component_el_space, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "mt-10",
              onClick: getEmailInfo,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              class: "mt-10",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (isShowExport.value=true))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (props.isInvoice)
      ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          key: 1,
          "max-height": tableHeight,
          class: "mt-10",
          onSelectionChange: handleSelectionChange,
          border: "",
          data: invoiceLists.value,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              width: "55"
            }),
            _createVNode(_component_el_table_column, {
              prop: "invoiceNo",
              label: "发票编号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "client",
              label: "客户"
            }),
            _createVNode(_component_el_table_column, {
              prop: "contact",
              label: "联系人"
            }),
            _createVNode(_component_el_table_column, {
              prop: "customerManager",
              label: "客户经理"
            }),
            _createVNode(_component_el_table_column, {
              prop: "amount",
              label: "总金额",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              prop: "currency",
              label: "货币"
            }),
            _createVNode(_component_el_table_column, {
              prop: "sendMail",
              label: "是否发送邮件",
              formatter: (row)=>row.sendMail?'已发送':'未发送'
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              prop: "createdAt",
              label: "生成日期",
              formatter: (row)=>_unref(dayjs)(row.createdAt).format('YYYY-MM-DD')
            }, null, 8, ["formatter"]),
            (props.isInvoice)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  label: "操作"
                }, {
                  default: _withCtx(({row}) => [
                    _createVNode(_component_el_link, {
                      class: "mr-10",
                      onClick: ($event: any) => (printInvoice(row,'print')),
                      underline: false
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_link, {
                      onClick: ($event: any) => (printInvoice(row,'download')),
                      underline: false
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, invoiceListsLoading.value]
        ])
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_8,
          (_unref(route).name=='invoice')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_button, { onClick: batchUploadHandle }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (vatRecordExoprt())),
                  loading: exportLoading.value
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_el_button, {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (vatRecordExoprt(true))),
                  loading: exportTempLoading.value
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_el_button, { onClick: updateHandle }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            onClick: bantchDownLoad,
            loading: bantchDownLoadLoading.value
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_el_button, {
            onClick: _cache[16] || (_cache[16] = ($event: any) => (isShowExport.value=true))
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }),
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            "show-summary": "",
            "summary-method": getSummaries,
            "max-height": tableHeight,
            "row-class-name": tableRowClassName,
            onSelectionChange: vatSelectionChange,
            class: "mt-10",
            border: "",
            data: invoiceLists.value,
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                fixed: "left",
                type: "selection",
                width: "55"
              }),
              _createVNode(_component_el_table_column, {
                fixed: "left",
                prop: "invoiceNo",
                label: "CO发票编号",
                width: "150"
              }),
              _createVNode(_component_el_table_column, {
                fixed: "left",
                prop: "customerName",
                label: "客户名称",
                width: "150"
              }),
              _createVNode(_component_el_table_column, {
                prop: "customerManager",
                label: "客户经理",
                width: "150"
              }),
              _createVNode(_component_el_table_column, {
                prop: "invoiceCompany",
                label: "CO系统组织",
                width: "150",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "companyName",
                label: "公司名称",
                width: "150",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "invoiceDate",
                label: "申请日期",
                width: "150"
              }),
              _createVNode(_component_el_table_column, {
                prop: "invoiceType",
                label: "发票类型",
                width: "150",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "buyerName",
                label: "购买方名称",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "taxNo",
                label: "税号",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "itemName",
                label: "项目名称",
                width: "120",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "hasUndelivered",
                label: "是否包含未交付订单",
                width: "170",
                "show-overflow-tooltip": ""
              }, {
                defult: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(row.hasUndelivered?'包含':'不包含'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "itemNo",
                label: "商品和服务税收编码",
                width: "170",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "specification",
                label: "规格型号",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "unit",
                label: "单位",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "quantity",
                label: "数量",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "unitPrice",
                label: "单价",
                width: "120",
                align: "right",
                formatter: _unref(formatNumber)
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                prop: "includingTaxStr",
                label: "是否含税",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "totalAmount",
                label: "开票金额",
                width: "160",
                align: "right",
                formatter: _unref(formatNumber)
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                prop: "advanceVatInvoiceAmount",
                label: "预付发票金额",
                width: "160",
                align: "right",
                formatter: _unref(formatNumber)
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                prop: "sumOrderAmount",
                label: "订单金额",
                width: "160",
                align: "right",
                formatter: _unref(formatNumber)
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                prop: "notes",
                label: "备注说明",
                width: "150",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "financialNotes",
                label: "补充说明",
                width: "150",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "invoiceStatus",
                label: "状态",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "isClose",
                label: "收款状态",
                width: "120",
                formatter: (row)=>row.isClose?'已收款':' '
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                prop: "realInvoiceDate",
                label: "开票日期",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "realNo",
                label: "发票号码",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "reason",
                label: "作废原因",
                width: "120",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                fixed: "right",
                width: _unref(route).name!='invoice'?'200':'170'
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_space, null, {
                    default: _withCtx(() => [
                      (_unref(route).name!='invoice')
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 0,
                            disabled: row.invoiceStatus!='已完成',
                            type: "primary",
                            onClick: ($event: any) => (recreateHandle(row)),
                            underline: false
                          }, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]))
                        : _createCommentVNode("", true),
                      (_unref(route).name!='invoice')
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 1,
                            disabled: row.invoiceStatus!='已完成',
                            type: "danger",
                            onClick: ($event: any) => (negateHandle(row)),
                            underline: false
                          }, {
                            default: _withCtx(() => [
                              _hoisted_16
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_link, {
                        onClick: ($event: any) => (getVatInvoiceOrders(row.id)),
                        underline: false
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      (_unref(route).name!='invoice')
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 2,
                            disabled: row.status!='WAIT_DELIVERED',
                            onClick: ($event: any) => (deliverHandle(row.id)),
                            underline: false
                          }, {
                            default: _withCtx(() => [
                              _hoisted_18
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]))
                        : _createCommentVNode("", true),
                      (_unref(route).name=='invoice')
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 3,
                            underline: false,
                            onClick: ($event: any) => (uploadHandle(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_19
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_unref(route).name=='invoice')
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 4,
                            underline: false,
                            type: "danger",
                            disabled: row.status=='VOID',
                            onClick: ($event: any) => (voidHandle(row.id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["width"])
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, invoiceListsLoading.value]
          ])
        ], 64)),
    _createVNode(_component_el_pagination, {
      class: "mt-15",
      "current-page": _unref(pageInfo).page,
      "onUpdate:current-page": _cache[17] || (_cache[17] = ($event: any) => ((_unref(pageInfo).page) = $event)),
      "page-size": _unref(pageInfo).size,
      "onUpdate:page-size": _cache[18] || (_cache[18] = ($event: any) => ((_unref(pageInfo).size) = $event)),
      onSizeChange: _cache[19] || (_cache[19] = ()=>getInvoiceLists()),
      onCurrentChange: _cache[20] || (_cache[20] = ()=>getInvoiceLists()),
      background: "",
      layout: "prev, pager, next, sizes",
      total: _unref(pageInfo).total,
      "page-sizes": [30, 60, 100, 120]
    }, null, 8, ["current-page", "page-size", "total"]),
    _createVNode(_component_el_dialog, {
      modelValue: vatInvoiceListVisiable.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((vatInvoiceListVisiable).value = $event)),
      title: "订单列表",
      width: "80%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: vatInvoiceOrderLists.value,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "no",
              label: "订单号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "client",
              label: "客户"
            }),
            _createVNode(_component_el_table_column, {
              prop: "contact",
              label: "联系人"
            }),
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "订单名称",
              width: "180",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "owner",
              label: "客户经理"
            }),
            _createVNode(_component_el_table_column, {
              prop: "creator",
              label: "创建人"
            }),
            _createVNode(_component_el_table_column, {
              prop: "poNumber",
              label: "PO号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "po",
              label: "PO"
            }),
            _createVNode(_component_el_table_column, {
              prop: "status",
              label: "订单状态"
            }),
            _createVNode(_component_el_table_column, {
              prop: "amount",
              label: "总金额",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              prop: "currency",
              label: "货币"
            }),
            _createVNode(_component_el_table_column, {
              prop: "startTime",
              label: "开始时间",
              sortable: "",
              formatter: (row)=>_unref(dayjs)(row.startTime).format('YYYY-MM-DD')
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              prop: "deliverTime",
              label: "交付时间",
              sortable: "",
              formatter: (row)=>_unref(dayjs)(row.deliverTime).format('YYYY-MM-DD')
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      onClose: _cache[29] || (_cache[29] = ($event: any) => (closeEmail(emailFormRef.value))),
      modelValue: emailVisiable.value,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((emailVisiable).value = $event)),
      title: "写邮件",
      width: "500"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[27] || (_cache[27] = ($event: any) => (emailVisiable.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: sendLoading.value,
          onClick: _cache[28] || (_cache[28] = ($event: any) => (sendEmail(emailFormRef.value)))
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "150",
          ref_key: "emailFormRef",
          ref: emailFormRef,
          model: emailInfo.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "收件人",
              prop: "toAddress",
              rules: [{required:true,message:'请输入联系人'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  autosize: "",
                  type: "textarea",
                  modelValue: emailInfo.value.toAddress,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((emailInfo.value.toAddress) = $event)),
                  placeholder: "多个联系人请用;分隔"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "联系人",
              prop: "contact",
              rules: [{required:true,message:'请输入联系人',trigger:'blur'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  autosize: "",
                  type: "textarea",
                  modelValue: emailInfo.value.contact,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((emailInfo.value.contact) = $event)),
                  placeholder: "请输入联系人"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "抄送",
              prop: "ccAddress"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  autosize: "",
                  type: "textarea",
                  modelValue: emailInfo.value.ccAddress,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((emailInfo.value.ccAddress) = $event)),
                  placeholder: "多个联系人请用;分隔"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "主题",
              prop: "title",
              rules: [{required:true,message:'请输入邮件主题',trigger:'blur'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: emailInfo.value.title,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((emailInfo.value.title) = $event)),
                  placeholder: " "
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "邮件模板",
              prop: "type",
              rules: [{required:true,message:'请输入邮件模板'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"flex":"1"},
                  modelValue: emailInfo.value.type,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((emailInfo.value.type) = $event)),
                  placeholder: "",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "CCJK",
                      value: "ccjk"
                    }),
                    _createVNode(_component_el_option, {
                      label: "MarsHub",
                      value: "marshub"
                    }),
                    _createVNode(_component_el_option, {
                      label: "MarsTranslation",
                      value: "marstranslation"
                    }),
                    _createVNode(_component_el_option, {
                      label: "ArtLangs",
                      value: "artlangs"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "1000",
      modelValue: uploadVisiable.value,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((uploadVisiable).value = $event)),
      onClose: _cache[33] || (_cache[33] = ($event: any) => (resetUpload(uploadRef.value))),
      title: "附件"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[31] || (_cache[31] = ($event: any) => (uploadVisiable.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_upload, {
          style: {"width":"100%"},
          ref_key: "uploadRef",
          ref: uploadRef,
          "http-request": uploadMethod,
          "show-file-list": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { loading: uploading.value }, {
              default: _withCtx(() => [
                _hoisted_23,
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Upload)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }, 512),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          class: "mt-10",
          data: vatUploadFiles.value,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "fileName",
              label: "发票名称",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "fileNo",
              label: "发票号",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "extension",
              label: "发票类型"
            }),
            _createVNode(_component_el_table_column, {
              prop: "amount",
              label: "金额",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              prop: "fileDate",
              label: "发票日期"
            }),
            _createVNode(_component_el_table_column, {
              prop: "ops",
              label: "操作"
            }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_el_button, {
                  loading: singleVatDownLoadLoading.value,
                  link: "",
                  onClick: ($event: any) => (bantchDownLoad(false,row.id)),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 2
                }, 1032, ["loading", "onClick"]),
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (vatDeleteHandle(row.id)),
                  link: "",
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, vatUploadFilesLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: batchDateVisiable.value,
      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((batchDateVisiable).value = $event)),
      onClose: resetHandle,
      title: "开票日期"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          loading: updateDateLoading.value,
          onClick: _cache[35] || (_cache[35] = ($event: any) => (batchDateVisiable.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_27
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, {
          loading: updateDateLoading.value,
          type: "primary",
          onClick: bantchHandle
        }, {
          default: _withCtx(() => [
            _hoisted_28
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_date_picker, {
          modelValue: batchInvoiceDate.value,
          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((batchInvoiceDate).value = $event)),
          type: "date",
          placeholder: "请选择开票日期"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: batchUploadVisiable.value,
      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((batchUploadVisiable).value = $event)),
      onClose: resetBatchUpload,
      center: "",
      title: "批量导入"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          loading: batchUploadLoading.value,
          type: "primary",
          onClick: bantchUploadMethod
        }, {
          default: _withCtx(() => [
            _hoisted_30
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_upload, {
          multiple: "",
          "auto-upload": false,
          ref_key: "batchUploadRef",
          ref: batchUploadRef,
          "file-list": fileList.value,
          "onUpdate:file-list": _cache[37] || (_cache[37] = ($event: any) => ((fileList).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, null, {
              default: _withCtx(() => [
                _hoisted_29,
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Upload)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["file-list"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "500",
      modelValue: negateReaonVisiable.value,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((negateReaonVisiable).value = $event)),
      onClose: _cache[42] || (_cache[42] = ($event: any) => (negateReason.value='')),
      title: "发票作废原因"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[40] || (_cache[40] = ($event: any) => (negateReaonVisiable.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_31
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: negateMethod
        }, {
          default: _withCtx(() => [
            _hoisted_32
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: negateReason.value,
          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((negateReason).value = $event)),
          placeholder: "请输入发票作废原因"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "导出",
      modelValue: isShowExport.value,
      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((isShowExport).value = $event)),
      onClose: _cache[46] || (_cache[46] = ($event: any) => (exportNos.value=''))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          loading: batchExportLoading.value,
          onClick: _cache[44] || (_cache[44] = ($event: any) => (isShowExport.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_33
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, {
          loading: batchExportLoading.value,
          type: "primary",
          onClick: batchExportHandle
        }, {
          default: _withCtx(() => [
            _hoisted_34
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          type: "textarea",
          placeholder: "请输入发票号，支持分隔符：, ; . /换行符，中文逗号或空格",
          rows: 4,
          modelValue: exportNos.value,
          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((exportNos).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})